module.exports = __webpack_public_path__ + "static/media/warehouse.38ecc11b.svg";